import axios from 'axios';
import { tokens } from '../../api/tokens';
import Cookies from 'js-cookie';
import { Token } from '../../interfaces/token';
import { users } from '../../api/users';
import { User } from '../../interfaces/user';
import dayjs from '../../helpers/dayjs';

async function authentication(
	username: string,
	password: string,
	withToken: boolean
): Promise<Token> {
	try {
		const data = await tokens.getToken(username, password);
		const token = `Basic ${window.btoa(`${data.token}:`)}`;
		axios.defaults.headers.common['Authorization'] = token;
		if (withToken) {
			Cookies.set(
				'Global-Token',
				JSON.stringify({
					id: data.id,
					token: token,
				}),
				{
					expires: dayjs().utc(true).add(4, 'h').toDate(),
					secure: process.env.NODE_ENV === 'production',
					sameSite: 'strict',
					path: process.env.REACT_APP_COOKIE_PATH,
					domain: process.env.REACT_APP_COOKIE_DOMAIN,
				}
			);
		}
		return data;
	} catch (error) {
		throw error;
	}
}

async function userAuthentication(id: number): Promise<User> {
	try {
		return await users.getUser(id);
	} catch (error) {
		throw error;
	}
}

async function siteSpecificAuthentication(
	clientId: number,
	siteId: number,
	withToken: boolean
): Promise<void> {
	try {
		const data = await tokens.getClientSiteToken(clientId, siteId);
		const token = `Basic ${window.btoa(`${data.token}:`)}`;
		axios.defaults.headers.common['Authorization'] = token;
		if (withToken) {
			Cookies.set(
				'Token',
				JSON.stringify({
					id: data.id,
					token: token,
				}),
				{
					expires: dayjs().utc(true).add(4, 'h').toDate(),
					secure: process.env.NODE_ENV === 'production',
					sameSite: 'strict',
					path: process.env.REACT_APP_COOKIE_PATH,
					domain: process.env.REACT_APP_COOKIE_DOMAIN,
				}
			);
		}
	} catch (error) {
		throw error;
	}
}

function logout(): void {
	Cookies.remove('Global-Token');
	Cookies.remove('Token');
}

export const authenticationService = {
	authentication,
	userAuthentication,
	siteSpecificAuthentication,
	logout,
};
